<div [ngStyle]="style" nz-tooltip [nzTooltipPlacement]="tooltipPlacement" [nzTooltipTitle]="showTooltip ? label : ''"
  class="pl-1 pr-1 text-xs rounded-full overflow-hidden"
  [ngClass]="{'underlineX': active === true, 'noUnderline': active === false}">
  <span *ngIf="showLabel" class="pl-1 pr-1 text-xs">
    {{label}}
    <ng-container *ngIf="showDeleteIcon" [ngTemplateOutlet]="icon" [ngTemplateOutletContext]="{$implicit: id}"></ng-container>
  </span>
</div>
